import { 
  Box, 
  Button, 
  Card, 
  Container, 
  Grid, 
  Paper, 
  Tab, 
  Tabs, 
  styled 
} from "@mui/material";

const MainContentArea = styled(Paper)(({theme}) => ({
  ...theme.flexBox.justifyAlignCenter,
  height: '100%',
  width: '100%',
  flexWrap: 'wrap',
  backgroundColor: 'transparent'
}));

const CustomTabsComponent = styled(Tabs)(({theme}) => ({
  width: '100%',
  flex: '5',
  overflowX: 'scroll',
  '.MuiTabs-scrollButtons': {
    color: `${theme.palette.whites.main}`
  },
  '.MuiTabs-scrollButtons.Mui-disabled': {
    opacity: 0.3
  },
  '& .Mui-selected': {
    color: `${theme.palette.whites.main}!important`
  },
  '& .MuiTabs-indicator': {
    backgroundColor: theme.palette.whites.main,
    height: 5,
  },
  color: `${theme.palette.secondary.md}!important`,
  display: 'flex',
  justifyContent: 'flex-start', // Centers the tabs
  '& .MuiTabs-flexContainer': {
    justifyContent: 'flex-start', // Centers the tabs within the container
  },
}));

const CustomTab = styled(Tab)(({ theme }) => ({
  color: `${theme.palette.whites.md}`
}));

const AvatarContainer = styled(Grid)(({theme}) => ({
  ...theme.flexBox.justifyStartAlignCenter,
  flex: '0.5',
  backgroundColor: `${theme.palette.primary.main}`,
  padding: '0!important',
  width: '100%',
}));

const TabsAndPanelsParentBox = styled(Box)(({theme}) => ({
  display: 'flex', 
  flexDirection: 'column', 
  width: '100%', 
  flex: '4', 
  // height: '100dvh',
  backgroundColor: `transparent`
}));

const TabPanelChildrenContainer = styled(Container)(() => ({
  height: '100%',
  margin: '0',
  width: '100%',
  maxWidth: '100%!important'
}));

const MainContentAreaChildGrid = styled(Grid)(() => ({
  width: '100%'           , 
  height: '100%'          ,
  display: 'flex'         ,
  flexDirection: 'column' ,
  flexWrap: 'nowrap'      ,
}));

const TabsBox = styled(Box)(({ theme }) => ({
  backgroundColor: `${theme.palette.primary.main}`,
  padding: '0 1rem',
  borderBottomLeftRadius: '2rem',  // Adjust size as needed
  borderBottomRightRadius: '2rem',
  border: `1px solid ${theme.palette.primary.main}`
}));

const ParentContainer = styled(Box)({
  height: '100%',
  width: '100%',
  display: 'flex',
  flexDirection: 'column',
});

const CarouselContainer = styled(Box)({
  flex: 1,
  width: '100%',
  overflow: 'hidden',
  position: 'relative',
  minHeight: '12rem',
  '&:hover .MuiIconButton-root': {
    opacity: 1,
  },
  marginTop: '1rem'
});

const CarouselTrack = styled(Box)({
  display: 'flex',
  overflow: 'hidden',
  scrollBehavior: 'smooth',
});

const CardListContainer = styled(Box)({
  flex: 2,
  overflowY: 'auto',
  padding: '1rem',
  paddingTop: '0'
});

const CustomCard = styled(Card)({
  width: '100%',
  height: '10rem',
  marginBottom: '1rem',
  display: 'flex',
  alignItems: 'center',
  position: 'relative', // Add this
});

const CardImage = styled('img')(({ theme }) => ({
  height: '100%',
  width: '15%',
  objectFit: 'cover',
  padding: '0.5rem',
  borderRadius: '1rem',
  [theme.breakpoints.down('md')]: {
    width: '150px',
    height: '150px'
  }
}));

const CardContent = styled(Box)({
  flex: 1,
  display: 'flex',
  flexDirection: 'column',
  padding: '0.5rem',
  justifyContent: 'space-between',
  marginRight: '20px', // Add space for the icon button
  overflow: 'hidden', // Ensure content doesn't overflow
});

const TagsContainer = styled(Box)({
  display: 'flex',
  gap: '0.5rem',
  overflow: 'hidden', // Hide overflow
  whiteSpace: 'nowrap', // Keep tags in single line
});

const SocialCard = styled(Card)({
  display: 'flex',
  alignItems: 'center',
  padding: '0.75rem',
  borderRadius: '2rem',
  marginBottom: '0.5rem',
  cursor: 'pointer',
  transition: 'transform 0.2s ease-in-out',
  '&:hover': {
    transform: 'translateY(-2px)',
  }
});

const BioContainer = styled(Box)(({ expanded }) => ({
  position: 'relative',
  marginBottom: '1rem',
  maxHeight: expanded ? 'none' : '150px', // Adjust this value as needed
  overflow: 'hidden',
  transition: 'max-height 0.3s ease-out',
}));

const BioOverlay = styled(Box)({
  position: 'absolute',
  bottom: 0,
  left: 0,
  right: 0,
  height: '70px',
  background: 'linear-gradient(to bottom, transparent, white)',
  pointerEvents: 'none',
});

const BaseButton = styled(Button)({
  position: 'absolute',
  bottom: 0,
  left: '50%',
  transform: 'translateX(-50%)',
  zIndex: 1,
  backgroundColor: 'white',
  border: '1px solid #ddd',
  borderRadius: '20px',
  padding: '4px 16px',
  cursor: 'pointer',
  '&:hover': {
    backgroundColor: '#f5f5f5',
  },
});

const CollapseButton = styled(BaseButton)({
  position: 'relative', // Override absolute positioning
  marginTop: '1rem',
  // Additional styles specific to collapse button if needed
});

export { 
  MainContentArea,
  MainContentAreaChildGrid,
  CustomTabsComponent,
  CustomTab,
  TabsAndPanelsParentBox,
  TabPanelChildrenContainer,
  AvatarContainer,
  TabsBox,
  CarouselContainer,
  CarouselTrack,
  ParentContainer,
  CardListContainer,
  CustomCard,
  CardImage,
  CardContent,
  TagsContainer,
  SocialCard,
  BioContainer,
  BioOverlay,
  BaseButton,
  CollapseButton
};